import { WithRouteData } from '../render-routes';
import { MyAccount as MyAccountPage } from '../pages';
import { IPage } from '../pages/types';
import React, { FC } from 'react';

export const MyAccount: FC<IPage> = (props) => <MyAccountPage {...props} />;

export default WithRouteData(MyAccount);
